import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("cs_token");
    if (!t) { setUser(null); setProfile(null); setLoading(false); return; }
    try {
      const data = await api.me();
      setUser(data.user);
      setProfile(data.profile);
    } catch {
      localStorage.removeItem("cs_token");
      setUser(null); setProfile(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = () => {
    localStorage.removeItem("cs_token");
    setUser(null); setProfile(null);
    window.location.href = "/";
  };

  return (
    <Ctx.Provider value={{ user, profile, loading, refresh, logout, setUser, setProfile }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
